import { render, staticRenderFns } from "./SfMegaMenu.vue?vue&type=template&id=5fe5717b"
import script from "./SfMegaMenu.vue?vue&type=script&lang=js"
export * from "./SfMegaMenu.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfMegaMenu.vue?vue&type=style&index=0&id=5fe5717b&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "0c4972e6"
  
)

export default component.exports